<template>
<svg data-svg-lvl-3="spread-block-contour" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514 430"><defs></defs><g id="Контур"><path class="lc-c-2" d="M256.8469,81.1533H83.7407c-6.6274,0-12,5.3726-12,12l-.0003,242.2529c0,6.6274,5.3726,12,12,12h346.2123c6.6274,0,12-5.3726,12-12V93.1533c0-6.6274-5.3726-12-12-12h-173.1058Z"/></g></svg></template>


<script>
/** Этот компонент генерируется автоматически, руками ничего менять нельзя!!! */
  
export default {props: { params: { type: Object, required: true, }, }, data() { return {} },}
</script>

<style scoped>.lc-c-1{opacity:.3;}.lc-c-2{fill:none;stroke:#232728;stroke-miterlimit:2;stroke-width:.7507px;}.lc-c-3{fill:#64ff00;stroke-width:0px;}</style>

